import { Api } from '@/services/Api'

export default {
  check () {
    return Api().post('/auth/login/check/')
  },
  signin (data) {
    // email, password
    return Api().post('/auth/login/', data)
  },
  signup (data) {
    // email, firstName, lastName
    return Api().post('/auth/register/', data)
  },
  signout () {
    return Api().post('/auth/logout/')
  },
  sendCode (data) {
    // email
    return Api().get('/auth/code/send/', { params: data })
  },
  verifyCode (data) {
    // email, token
    return Api().get('/auth/code/verify/', { params: data })
  },
  resetPassword (data) {
    // email, token, password
    return Api().patch('/auth/password/reset/', data)
  },
  changePassword (data) {
    // email, oldPassworld, newPassworld
    return Api().patch('/auth/password/change/', data)
  }
}
